/** Reset in-memory chat when the authenticated user changes without a logout. */
export function shouldResetChatOnUserChange(
  prevUserId: number | null,
  nextUserId: number | null,
): boolean {
  if (prevUserId == null || nextUserId == null) return false;
  return prevUserId !== nextUserId;
}
